(function() {
    'use strict';
    /*
     * Copyright (c) 2015 In Hand Health.
     * All rights reserved.
     */

    /**
     * A dialog controller for choosing between existing user data and newly entered user data.
     */
    angular
        .module('ihh-common-web')
        .controller('PersonConflictCtrl', PersonConflictCtrl);

    PersonConflictCtrl.$inject = ['$scope', '$modalInstance', 'secondaryIndividual', 'person'];

    function PersonConflictCtrl($scope, $modalInstance, secondaryIndividual, person) {

        $scope.secondaryIndividual = secondaryIndividual;
        $scope.person = person;

        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };

        $scope.context = secondaryIndividual.clinic ? ' in your clinic' : '';

        /**
         * A choose function to attached to the OK button...return true to use the person name instead of what the user entered.
         */
        $scope.chooseExisting = function() {
            $modalInstance.close(true);
        };

        /**
         * A choose function to attached to the OK button...return false to use what the user entered, not the person name.
         */
        $scope.chooseEntered = function() {
            $modalInstance.close(false);
        };
    }
})();